import React from 'react'
import { useForm, useError } from '../../hooks'
import DropdownField from '../Form/DropdownField'
import Button from '../Button'
import ContextMenu from '../ContextMenu'
import { doc, updateDoc } from 'firebase/firestore'
import { db } from '../../firebase'

export const STATUS_TYPES = ['pending', 'inprogress', 'ended']

function capitalize(s) {
  return `${s.slice(0, 1).toUpperCase()}${s.slice(1)}`
}

export default function ({ incident, onFinishEditing }) {
  const setError = useError()
  const [getFieldProps, formData, formError] = useForm()

  async function handleSubmit(e) {
    e.preventDefault()

    try {
      const incidentRef = doc(db, 'incidents', incident.id)
      await updateDoc(incidentRef, {
        status: formData.status
      })

      // If status is changed back to active, restore chat room
      if (['pending', 'inprogress'].includes(formData.status)) {
        const chatId = incident.chatId || `incident_${incident.id}`
        const chatRef = doc(db, 'chats', chatId)
        await updateDoc(chatRef, {
          isDeleted: false
        })
      }

      onFinishEditing()
    } catch (err) {
      setError(err)
    }
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <DropdownField
          name='status'
          label='Status'
          defaultValue={incident.status}
          required={true}
          {...getFieldProps()}>
          {STATUS_TYPES.map((type) => (
            <option value={type} key={type}>
              {capitalize(type)}
            </option>
          ))}
        </DropdownField>
        <div className='flex justify-end'>
          <Button type='submit'>Update</Button>
        </div>
      </form>
    </div>
  )
}